import { useEffect, useState } from 'react';
import { supabase } from '@/lib/supabaseClient';

export function useSession() {
  const [session, setSession] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let ignore = false;

    const loadInitial = async () => {
      const { data } = await supabase.auth.getSession();
      if (!ignore) {
        setSession(data.session);
        setLoading(false); 
      }
    };

    loadInitial();

    const { data: listener } = supabase.auth.onAuthStateChange(
      (_event, newSession) => {
        if (!ignore) {
          setSession(newSession); 
        }
      }
    );

    return () => {
      ignore = true;
      listener.subscription.unsubscribe();
    };
  }, []);

  return { session, loading };
}